import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import { AvatarModule } from '@libs/src/avatar/avatar.module';
import { HubCardModule } from '@main-client/src/app/hubs/hub-card/hub-card.module';
import { OnboardingBackgroundFlairModule } from '@main-client/src/app/onboarding-background-flair/onboarding-background-flair.module';

import { UserOnboardingViewHubsComponent } from './user-onboarding-view-hubs.component';

@NgModule({
  declarations: [UserOnboardingViewHubsComponent],
  exports: [UserOnboardingViewHubsComponent],
  imports: [
    AvatarModule,
    CommonModule,
    FlexLayoutModule,
    HubCardModule,
    InfiniteScrollModule,
    MatButtonModule,
    MatProgressBarModule,
    OnboardingBackgroundFlairModule,
  ],
})
export class UserOnboardingViewHubsModule {}
